if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);

          // Ensure the details remain open
          this.ensureDetailsOpen(event);

          // Focus on the next input element
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }

      ensureDetailsOpen(event) {
        // Find the closest <details> element by traversing upwards in the DOM from the button
        const details = event.target.closest('.parent-display').closest('details');

        console.log('Details element found:', details);

        if (details) {
          // Ensure the 'open' attribute is set and persists
          this.keepDetailsOpen(details);
        } else {
          console.error('Details element not found!');
        }
      }

      // Function to ensure that the 'open' attribute is set and persisted
      keepDetailsOpen(details) {
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }

        // Set up a MutationObserver to ensure that the 'open' attribute isn't removed
        const observer = new MutationObserver(() => {
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
          }
        });

        // Observe the details element for changes in its attributes
        observer.observe(details, {
          attributes: true, // Listen for attribute changes
          attributeFilter: ['open'], // Focus only on the 'open' attribute
        });

        // To prevent multiple observers, we disconnect the observer after a while
        setTimeout(() => {
          observer.disconnect();
        }, 5000); // Disconnect after 5 seconds to prevent performance issues
      }
    }
  );
}
